import { firestore } from 'firebase/app';
import { Doc, DocReference } from './Document';

export interface ICommentContainer {
  __comments: {
    countWthoutReplies: number;
    countWithReplies: number;
    title: string;
    href: string;
    metadata?: any;
  };
}

export enum CommentStatus {
  PENDING = 'PENDING',
  PUBLISHED = 'PUBLISHED',
  REMOVED = 'REMOVED'
}

export enum CommentRemoveReason {
  NONE = 'NONE',
  VIOLATION = 'VIOLATION'
}

export type CommentActorUser = {
  id: string;
  type: 'USER';
};
export type CommentActorGuest = {
  name: string;
  email: string;
  website: string;
  type: 'GUEST';
};

export type CommentActor = CommentActorUser | CommentActorGuest;

export interface IComment {
  body: string; // markdown!

  createdBy: CommentActor;
  createdAt: firestore.Timestamp;
  editedBy: CommentActor;
  editedAt: firestore.Timestamp;
  publishedBy: CommentActor | null;
  publishedAt: firestore.Timestamp | null;

  status: CommentStatus;

  entityRef: DocReference;
  parentRef: DocReference | null;

  pinned: boolean;
  pinnedBy: CommentActor | null;
  pinnedAt: firestore.Timestamp | null;

  removedBy: CommentActor | null;
  removedAt: firestore.Timestamp | null;
  removeReason: CommentRemoveReason | null;

  replyCount: number;
}

export interface ICommentWithReplies extends IComment {
  replies: Doc<ICommentWithReplies>[];
}
